import { put, race, takeEvery, join, cancelled, call, putResolve } from 'redux-saga/effects'
import { CHANNEL_DATA } from 'CHANNEL_DATA'
import { createSagasActions } from 'utils/sagas'
import {
  setLoadStatus
} from '../redux/view'
import fetchView from './fetchView'
import viewError from 'store/sagas/viewError'
import channelData from './channelData'

export const NAMESPACE = 'KanBo/Home/sagas/'
export const FETCH_BOARDS_BLOCKER_COUNT = NAMESPACE + 'FETCH_BOARDS_BLOCKER_COUNT'
export const FETCH_HOME_LAYOUT = NAMESPACE + 'FETCH_HOME_LAYOUT'
export const FETCH_MY_HOME_LAYOUTS = NAMESPACE + 'FETCH_MY_HOME_LAYOUTS'
export const FETCH_PERMISSION_LEVEL_FOR_LAYOUT = NAMESPACE + 'FETCH_PERMISSION_LEVEL_FOR_LAYOUT'
export const FETCH_UNREAD_BOARD_ACTIVITIES = NAMESPACE + 'FETCH_UNREAD_BOARD_ACTIVITIES'
export const FETCH_USERS = NAMESPACE + 'FETCH_USERS'
export const FETCH_VIEW = NAMESPACE + 'FETCH_VIEW'
export const REQUEST_ACTIVATE_USER = NAMESPACE + 'REQUEST_ACTIVATE_USER'
export const REQUEST_ADD_BOARD = NAMESPACE + 'REQUEST_ADD_BOARD'
export const REQUEST_ADD_BOARD_TEMPLATE_FROM_FILE = NAMESPACE + 'REQUEST_ADD_BOARD_TEMPLATE_FROM_FILE'
export const REQUEST_ADD_LAYOUT = NAMESPACE + 'REQUEST_ADD_LAYOUT'
export const REQUEST_ADD_LAYOUT_GROUP = NAMESPACE + 'REQUEST_ADD_LAYOUT_GROUP'
export const REQUEST_ADD_LAYOUT_TEMPLATE_FROM_FILE = NAMESPACE + 'REQUEST_ADD_LAYOUT_TEMPLATE_FROM_FILE'
export const REQUEST_ADD_LINK_TO_LAYOUT_GROUP = NAMESPACE + 'REQUEST_ADD_LINK_TO_LAYOUT_GROUP'
export const REQUEST_ADD_MY_LAYOUT = NAMESPACE + 'REQUEST_ADD_MY_LAYOUT'
export const REQUEST_ADD_BOARD_TO_LAYOUT_GROUP = NAMESPACE + 'REQUEST_ADD_BOARD_TO_LAYOUT_GROUP'
export const REQUEST_ADD_USERS_FROM_FILE_TO_KANBO = NAMESPACE + 'REQUEST_ADD_USERS_FROM_FILE_TO_KANBO'
export const REQUEST_ADD_USER_TO_KANBO = NAMESPACE + 'REQUEST_ADD_USER_TO_KANBO'
export const REQUEST_ADD_USER_TO_LAYOUT = NAMESPACE + 'REQUEST_ADD_USER_TO_LAYOUT'
export const REQUEST_CHANGE_LAYOUT_DESCRIPTION = NAMESPACE + 'REQUEST_CHANGE_LAYOUT_DESCRIPTION'
export const REQUEST_CHANGE_LAYOUT_NAME = NAMESPACE + 'REQUEST_CHANGE_LAYOUT_NAME'
export const REQUEST_CHANGE_LINK_IN_LAYOUT_GROUP = NAMESPACE + 'REQUEST_CHANGE_LINK_IN_LAYOUT_GROUP'
export const REQUEST_CHANGE_SETTINGS = NAMESPACE + 'REQUEST_CHANGE_SETTINGS'
export const REQUEST_COPY_LAYOUT = NAMESPACE + 'REQUEST_COPY_LAYOUT'
export const REQUEST_DEACTIVATE_USER = NAMESPACE + 'REQUEST_DEACTIVATE_USER'
export const REQUEST_MARK_BOARD_AS_READ = NAMESPACE + 'REQUEST_MARK_BOARD_AS_READ'
export const REQUEST_OPEN_BOARD = NAMESPACE + 'REQUEST_OPEN_BOARD'
export const REQUEST_POSITION_LAYOUT = NAMESPACE + 'REQUEST_POSITION_LAYOUT'
export const REQUEST_POSITION_LAYOUT_GROUP_ELEMENT = NAMESPACE + 'REQUEST_POSITION_LAYOUT_GROUP_ELEMENT'
export const REQUEST_REMOVE_LAYOUT = NAMESPACE + 'REQUEST_REMOVE_LAYOUT'
export const REQUEST_POSITION_LAYOUT_GROUP = NAMESPACE + 'REQUEST_POSITION_LAYOUT_GROUP'
export const REQUEST_REMOVE_ELEMENT_FROM_LAYOUT_GROUP = NAMESPACE + 'REQUEST_REMOVE_ELEMENT_FROM_LAYOUT_GROUP'
export const REQUEST_REMOVE_LAYOUT_GROUP = NAMESPACE + 'REQUEST_REMOVE_LAYOUT_GROUP'
export const REQUEST_REMOVE_MY_LAYOUT = NAMESPACE + 'REQUEST_REMOVE_MY_LAYOUT'
export const REQUEST_REMOVE_USER_FROM_LAYOUT = NAMESPACE + 'REQUEST_REMOVE_USER_FROM_LAYOUT'
export const REQUEST_RENAME_LAYOUT_GROUP = NAMESPACE + 'REQUEST_RENAME_LAYOUT_GROUP'
export const REQUEST_SET_LAYOUT_AS_PRIVATE = NAMESPACE + 'REQUEST_SET_LAYOUT_AS_PRIVATE'
export const REQUEST_SET_LAYOUT_AS_PUBLIC = NAMESPACE + 'REQUEST_SET_LAYOUT_AS_PUBLIC'
export const REQUEST_SET_USER_GROUP_PERMISSION_IN_HOME_LAYOUT = NAMESPACE + 'REQUEST_SET_USER_GROUP_PERMISSION_IN_HOME_LAYOUT'
export const REQUEST_UPLOAD_START = NAMESPACE + 'REQUEST_UPLOAD_START'

const { getSagas, actionCreators } = createSagasActions([
  [FETCH_BOARDS_BLOCKER_COUNT, 'fetchBoardsBlockerCount', require('./fetchBoardsBlockerCount').default],
  [FETCH_HOME_LAYOUT, 'fetchHomeLayout', require('./fetchHomeLayout').default],
  [FETCH_MY_HOME_LAYOUTS, 'fetchMyHomeLayouts', require('./fetchMyHomeLayouts').default, { takeLatest: true }],
  [FETCH_PERMISSION_LEVEL_FOR_LAYOUT, 'fetchPermissionLevelForLayout', require('./fetchPermissionLevelForLayout').default],
  [FETCH_UNREAD_BOARD_ACTIVITIES, 'fetchUnreadBoardsActivities', require('./fetchUnreadBoardsActivities').default],
  [FETCH_USERS, 'fetchUsers', require('./fetchUsers').default, { takeLatest: true }],
  [FETCH_VIEW, 'fetchView', require('./fetchView').default],
  [REQUEST_ACTIVATE_USER, 'requestActivateUser', require('./requestActivateUser').default],
  [REQUEST_ADD_BOARD, 'requestAddBoard', require('./requestAddBoard').default],
  [REQUEST_ADD_BOARD_TEMPLATE_FROM_FILE, 'requestAddBoardTemplateFromFile', require('./requestAddBoardTemplateFromFile').default],
  [REQUEST_ADD_LAYOUT, 'requestAddLayout', require('./requestAddLayout').default],
  [REQUEST_ADD_LAYOUT_GROUP, 'requestAddLayoutGroup', require('./requestAddLayoutGroup').default],
  [REQUEST_ADD_LAYOUT_TEMPLATE_FROM_FILE, 'requestAddLayoutTemplateFromFile', require('./requestAddLayoutTemplateFromFile').default],
  [REQUEST_ADD_LINK_TO_LAYOUT_GROUP, 'requestAddLinkToLayoutGroup', require('./requestAddLinkToLayoutGroup').default],
  [REQUEST_ADD_MY_LAYOUT, 'requestAddMyLayout', require('./requestAddMyLayout').default],
  [REQUEST_ADD_BOARD_TO_LAYOUT_GROUP, 'requestAddBoardToLayoutGroup', require('./requestAddBoardToLayoutGroup').default],
  [REQUEST_ADD_USERS_FROM_FILE_TO_KANBO, 'requestAddUsersFromFileToKanBo', require('./requestAddUsersFromFileToKanBo').default],
  [REQUEST_ADD_USER_TO_KANBO, 'requestAddUserToKanBo', require('./requestAddUserToKanBo').default],
  [REQUEST_ADD_USER_TO_LAYOUT, 'requestAddUserToLayout', require('./requestAddUserToLayout').default],
  [REQUEST_CHANGE_LAYOUT_DESCRIPTION, 'requestChangeLayoutDescription', require('./requestChangeLayoutDescription').default],
  [REQUEST_CHANGE_LAYOUT_NAME, 'requestChangeLayoutName', require('./requestChangeLayoutName').default],
  [REQUEST_CHANGE_LINK_IN_LAYOUT_GROUP, 'requestChangeLinkInLayoutGroup', require('./requestChangeLinkInLayoutGroup').default],
  [REQUEST_CHANGE_SETTINGS, 'requestChangeSettings', require('./requestChangeSettings').default],
  [REQUEST_COPY_LAYOUT, 'requestCopyLayout', require('./requestCopyLayout').default],
  [REQUEST_DEACTIVATE_USER, 'requestDeactivateUser', require('./requestDeactivateUser').default],
  [REQUEST_MARK_BOARD_AS_READ, 'requestMarkBoardAsRead', require('./requestMarkBoardAsRead').default, { takeLatest: true }],
  [REQUEST_OPEN_BOARD, 'requestOpenBoard', require('./requestOpenBoard').default],
  [REQUEST_POSITION_LAYOUT, 'requestPositionLayout', require('./requestPositionLayout').default],
  [REQUEST_POSITION_LAYOUT_GROUP_ELEMENT, 'requestPositionLayoutGroupElement', require('./requestPositionLayoutGroupElement').default],
  [REQUEST_POSITION_LAYOUT_GROUP, 'requestPositionLayoutGroup', require('./requestPositionLayoutGroup').default],
  [REQUEST_REMOVE_ELEMENT_FROM_LAYOUT_GROUP, 'requestRemoveElementFromLayoutGroup', require('./requestRemoveElementFromLayoutGroup').default],
  [REQUEST_REMOVE_LAYOUT, 'requestRemoveLayout', require('./requestRemoveLayout').default],
  [REQUEST_REMOVE_LAYOUT_GROUP, 'requestRemoveLayoutGroup', require('./requestRemoveLayoutGroup').default],
  [REQUEST_REMOVE_MY_LAYOUT, 'requestRemoveMyLayout', require('./requestRemoveMyLayout').default],
  [REQUEST_REMOVE_USER_FROM_LAYOUT, 'requestRemoveUserFromLayout', require('./requestRemoveUserFromLayout').default],
  [REQUEST_RENAME_LAYOUT_GROUP, 'requestRenameLayoutGroup', require('./requestRenameLayoutGroup').default],
  [REQUEST_SET_LAYOUT_AS_PRIVATE, 'requestSetLayoutAsPrivate', require('./requestSetLayoutAsPrivate').default],
  [REQUEST_SET_LAYOUT_AS_PUBLIC, 'requestSetLayoutAsPublic', require('./requestSetLayoutAsPublic').default],
  [REQUEST_SET_USER_GROUP_PERMISSION_IN_HOME_LAYOUT, 'requestSetUserGroupPermissionInHomeLayout', require('./requestSetUserGroupPermissionInHomeLayout').default],
  [REQUEST_UPLOAD_START, 'requestUploadStart', require('./requestUploadStart').default],
])

export const sagaActions = actionCreators

export function * landingPageActionsListener () {
  try {
    yield race([
      ...getSagas(),
    ])
  } catch (error) {
    yield putResolve(viewError({
      error,
      refresh: true
    }))
  }
}

export function * init () {
  try {
    yield put(setLoadStatus({
      isLoading: true,
    }))

    const forkedChannelDataListener = yield takeEvery(CHANNEL_DATA, channelData)

    yield call(fetchView)

    yield put(setLoadStatus({
      isLoading: false,
      isLoaded: true
    }))

    yield join(forkedChannelDataListener)
  } catch (error) {
    yield putResolve(viewError({
      error,
      refresh: true
    }))
  } finally {
    if (yield cancelled()) {
      yield put(setLoadStatus({
        isLoading: false,
        isLoaded: false
      }))
    }
  }
}
